import type { CurrentCart, LanguageIsoCode } from '@/graphql/graphql';
import { createContext, useContext } from 'react';

interface CartContextValue {
    cart: CurrentCart | null;
    refreshCart: () => Promise<CurrentCart | null>;
    addToCart: (programId: string, language: LanguageIsoCode, excludeEpisodeIds?: string[]) => Promise<void>;
    removeFromCart: (programId: string, language: LanguageIsoCode) => Promise<void>;
    updateCart: (programId: string, currentLanguage: LanguageIsoCode, newLanguage: LanguageIsoCode) => Promise<void>;
}

export const CartContext = createContext<CartContextValue | null>(null);

export const useCart = (): CartContextValue => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};
